import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Tv, Smartphone, Zap } from "lucide-react";

export default function Landing() {
  const nav = useNavigate();
  return (
    <div className="neon-bg min-h-screen flex flex-col items-center justify-center px-5 py-10 relative">
      <div className="relative z-10 w-full max-w-3xl flex flex-col items-center text-center">
        <motion.div initial={{ scale: 0.7, opacity: 0 }} animate={{ scale: 1, opacity: 1 }}
          transition={{ type: "spring", stiffness: 180, damping: 14 }}
          className="flex items-center gap-2 mb-5">
          <Zap className="w-9 h-9 text-[#FFD700]" fill="#FFD700" />
          <span className="font-head text-lg uppercase tracking-[0.35em] text-cyan-300">Party Game</span>
          <Zap className="w-9 h-9 text-[#FFD700]" fill="#FFD700" />
        </motion.div>

        <motion.h1 initial={{ y: 30, opacity: 0 }} animate={{ y: 0, opacity: 1 }} transition={{ delay: 0.1 }}
          className="font-display font-black uppercase leading-[0.95] text-5xl sm:text-6xl lg:text-7xl tracking-tight">
          <span className="text-white text-glow-magenta">Gimme a</span>
          <span className="block bg-gradient-to-r from-[#FF2A85] via-[#8B5CF6] to-[#00F0FF] bg-clip-text text-transparent">sQuizz</span>
        </motion.h1>

        <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.25 }}
          className="mt-5 text-base sm:text-lg text-white/70 max-w-md font-head">
          The TV is the stage. Your phone is the buzzer. Grab 2–12 friends and play.
        </motion.p>

        <div className="mt-12 grid sm:grid-cols-2 gap-5 w-full">
          <motion.button data-testid="landing-host-button" onClick={() => nav("/host")}
            whileHover={{ scale: 1.03 }} whileTap={{ scale: 0.97 }}
            className="glass glow-magenta rounded-3xl p-8 flex flex-col items-center gap-3 border-2 border-[#FF2A85]/40 hover:border-[#FF2A85] transition-colors">
            <div className="w-16 h-16 rounded-2xl bg-[#FF2A85]/20 flex items-center justify-center">
              <Tv className="w-9 h-9 text-[#FF2A85]" />
            </div>
            <span className="font-display font-bold text-xl text-white">Host on this screen</span>
            <span className="text-sm text-white/60">Open on a TV — set up from your phone via QR</span>
          </motion.button>

          <motion.button data-testid="landing-join-button" onClick={() => nav("/play")}
            whileHover={{ scale: 1.03 }} whileTap={{ scale: 0.97 }}
            className="glass glow-cyan rounded-3xl p-8 flex flex-col items-center gap-3 border-2 border-[#00F0FF]/40 hover:border-[#00F0FF] transition-colors">
            <div className="w-16 h-16 rounded-2xl bg-[#00F0FF]/20 flex items-center justify-center">
              <Smartphone className="w-9 h-9 text-[#00F0FF]" />
            </div>
            <span className="font-display font-bold text-xl text-white">Join a game</span>
            <span className="text-sm text-white/60">Enter a code on your phone to play</span>
          </motion.button>
        </div>
      </div>
    </div>
  );
}
